<template>
    <div class="tab-bar">
        <div :class="type == 1?'act link':'link'" @click="$router.push('/')">
            <img v-if="type == 1" src="https://oss.mifengbangzu.com/web/home_a.png?x-oss-process=image/resize,p_30" alt="">
            <img v-else src="https://oss.mifengbangzu.com/web/home.png?x-oss-process=image/resize,p_30" alt="">
            <p>首页</p>
        </div>
        <div  :class="type == 2?'act link':'link'" @click="goLook">
            <img v-if="type==2" src="https://oss.mifengbangzu.com/web/look_a.png?x-oss-process=image/resize,p_30" alt="">
            <img v-else src="https://oss.mifengbangzu.com/web/user.png?x-oss-process=image/resize,p_30" alt="">
            <p>运长安家</p>
        </div>
        <div  :class="type == 3?'act link':'link'" @click="$router.push('/my')">
            <img v-if="type != 3" src="https://oss.mifengbangzu.com/web/my.png?x-oss-process=image/resize,p_30" alt="">
            <img v-else src="https://oss.mifengbangzu.com/web/my_a.png?x-oss-process=image/resize,p_30" alt="">
            <p>我的</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'tabBar',
        data() {
            return {
                focus: false,
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            btnText: {
                type: String,
                default: ''
            },
            type: { // type: 1 空页面， 2：网络错误页
                type: Number,
                default: 1,
            },
        },
        computed: {

        },
        methods:{
            goLook(){
                location.href = '/look'
            }
        }
    }
</script>
<style lang="scss" scoped>
    .tab-bar{
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 7;
        width: 100%;
        height: .98rem;
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow:0px -2px 8px 0px rgba(0,0,0,0.08);
        .link{
            width: 33.33%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img{
                width: .5rem;
            }
            p{
                font-size: .24rem;
                color: #333333;
                line-height: .34rem;
            }
            &.act{
                p{
                    color: #EE8002;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TabBar/index.vue